// --- Compare-at-Price Erweiterung (nur Streichpreis) ---
/*const COMPARE_VALUES = {
  shipping_free_from: 79,
  shipping_value: 9.00,

  berry_free_from: 99,
  berry_value: 6.90,

  product1_value: 6.90,
  product1_treshhold:0

}; */
var element;
var elementOffsetTop = 0;
var scrollPosition = $(window).scrollTop();
/*
setTimeout(function(){
  if($('.bundle_add_to_cart_options_step').length > 0){
    element = $('.bundle_add_to_cart_options_step');

    var content_height = $('.main-product .product-text').height();
    var bundles_height = $('.bundle_add_to_cart_options_step').height();
    
    var gal_height = $('.product-gallery').height();
    var totalHeight = 0;
    
    element.prevAll('.bundle_multistep__step').each(function() {
      totalHeight += $(this).outerHeight(true); // Include margin in the height calculation
    });
  
    if(totalHeight > 0){
      totalHeight = parseFloat(totalHeight) + parseFloat(gal_height);
    }

    var alloverHeight = (content_height - bundles_height);

    

    if($(window).width() > 1900){
      elementOffsetTop = (alloverHeight - 800);
    }else if($(window).width() > 480 && $(window).width() < 1900){
      elementOffsetTop = (alloverHeight - 400);
    }else{
      elementOffsetTop = (alloverHeight - 200);
    } 

    
     if($(window).width() <= 767){
      if($(window).scrollTop() > elementOffsetTop){
        element.addClass('disable_displace');
        element.removeClass('fixed');
        element.find('.shipping-text-grid').hide();
      }else{
        element.removeClass('disable_displace');
        element.addClass('fixed');
        element.find('.shipping-text-grid').show();
      }
    }
      else{
            if(scrollPosition > elementOffsetTop){
              element.addClass('disable_displace');
              element.removeClass('fixed');
              element.find('.shipping-text-grid').hide();
            }
    else{
              element.removeClass('disable_displace');
              element.addClass('fixed');
              element.find('.shipping-text-grid').show();
            }
          }
    
// ------
    window.onresize = function() {
         if (window.innerWidth <= 767) {
        if($(window).scrollTop() > elementOffsetTop){
          element.addClass('disable_displace');
          element.removeClass('fixed');
          element.find('.shipping-text-grid').hide();
        }else{
          element.removeClass('disable_displace');
          element.addClass('fixed');
          element.find('.shipping-text-grid').show();
        }
      }
    
      else{
            if(scrollPosition > elementOffsetTop){
              element.addClass('disable_displace');
              element.removeClass('fixed');
              element.find('.shipping-text-grid').hide();
            }else{
              element.removeClass('disable_displace');
              element.addClass('fixed');
              element.find('.shipping-text-grid').show();
            }
          }
      
  }  
    }
}, 500); */


document.addEventListener("DOMContentLoaded", function () {
  
  let triggerSection = document.querySelector(".bundle_price-container");
  const stickySection = document.querySelector(".buyBox-sticky-atc-wrapper");
  const stickyHeader = document.querySelector('.sticky-header');

  if (!stickySection) return;

  if (!triggerSection) {
    triggerSection = document.querySelector(".product__cart-functions");
  }

  let lastScrollY = window.scrollY;

  function getScrollDirection() {
    const currentScrollY = window.scrollY;
    const direction = currentScrollY > lastScrollY ? 'down' : 'up';
    lastScrollY = currentScrollY;
    return direction;
  }

  function updateStickyPosition() {
    if (stickyHeader && stickyHeader.classList.contains('show')) {
      stickySection.style.top = `${stickyHeader.offsetHeight}px`;
    } else {
      stickySection.style.top = `0px`;
    }
  }

  function handleSticky() {
    const scrollY = window.scrollY;
    const triggerBottom = triggerSection.offsetTop + triggerSection.offsetHeight;
    const direction = getScrollDirection();

    updateStickyPosition();

    if (scrollY > triggerBottom && direction === 'down') {
      stickySection.classList.add("active");
    }

    if (scrollY <= triggerBottom && direction === 'up') {
      stickySection.classList.remove("active");
    }
  }

  if (window.innerWidth <= 575) {
    // For mobile layout with special layout check
    if (!document.querySelector('.product-layout-multistep')) {
      //stickySection.classList.add("active");
    } else {
      stickySection.classList.remove("active");
    }

    window.addEventListener("scroll", function () {
      const direction = getScrollDirection();
      const rect = triggerSection.getBoundingClientRect();

      if (rect.bottom <= 0 && direction === 'down') {
        stickySection.classList.add("active");
      } else if (rect.bottom > 0 && direction === 'up') {
        stickySection.classList.remove("active");
      }
    });

  } else {
    // Desktop version
    window.addEventListener("scroll", handleSticky);
  }
});


const bundleProductData = {
  productId: '9627628536086',
  variantId: '48874100031766',
  sellingPlan: 9480732950,
  handle: 'starter-bundle',
}

const bundle = {
  "externalVariantId": bundleProductData.variantId,
  "externalProductId": bundleProductData.productId,
  "selections": [
    {
      "collectionId": "458384736534",
      "externalProductId": "8560585277718",
      "externalVariantId": "46181509202198",
      "quantity": 2,
      "sellingPlan": 9493840150,
    },
    {
      "collectionId": "458384736534",
      "externalProductId": "8560586227990",
      "externalVariantId": "46181512577302",
      "quantity": 2,
      "sellingPlan": 9497870614
    }
  ]
};

const cartItems = recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
const cartData = { items: cartItems };

/* fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(cartData),
});  */


jQuery(document).ready(function($){
  /****************/
  let COMPARE_VALUES = {
    shipping_free_from: 79,
    shipping_value: 9.00,
    product1_threshold: 0,
    product1_value: 6.90,
    product2_threshold: 99,
    product2_value: 6.90,
    product3_threshold: 0,
    product3_value: 0
  };


  var $bundle = $('.bundle_multistep__step.bundle_flavour_step');

  let total1 = $bundle.data('totalproductSelected1') ?? 0;
  let discount1 = $bundle.data('discount_amount_per_product1') ?? 0;

  let total2 = $bundle.data('total_products_selected2') ?? 0;
  let discount2 = $bundle.data('discount_amount_per_product2') ?? 0;

  let total3 = $bundle.data('total_products_selected3') ?? 0;
  let discount3 = $bundle.data('discount_amount_per_product3') ?? 0;

  console.log(total1, discount1, total2, discount2, total3, discount3);

  const $multiStep = $('.product-layout-multistep');

  function getNumberAttr(attrName, fallback) {
    const raw = $multiStep.attr(attrName);
    const parsed = parseFloat(raw);
    return !isNaN(parsed) ? parsed : fallback;
  }

  COMPARE_VALUES.shipping_free_from = getNumberAttr(
    'data-shipping-threshold',
    COMPARE_VALUES.shipping_free_from
  );

  COMPARE_VALUES.shipping_value = getNumberAttr(
    'data-shipping-value',
    COMPARE_VALUES.shipping_value
  );

  COMPARE_VALUES.product1_threshold = getNumberAttr(
    'data-product1-threshold',
    COMPARE_VALUES.product1_threshold
  );

  COMPARE_VALUES.product1_value = getNumberAttr(
    'data-product1-value',
    COMPARE_VALUES.product1_value
  );

  COMPARE_VALUES.product2_threshold = getNumberAttr(
    'data-product2-threshold',
    COMPARE_VALUES.product2_threshold
  );

  COMPARE_VALUES.product2_value = getNumberAttr(
    'data-product2-value',
    COMPARE_VALUES.product2_value
  );

  COMPARE_VALUES.product3_threshold = getNumberAttr(
    'data-product3-threshold',
    COMPARE_VALUES.product3_threshold
  );

  COMPARE_VALUES.product3_value = getNumberAttr(
    'data-product3-value',
    COMPARE_VALUES.product3_value
  );

  function roundToNearestFive(price) {
    price = parseFloat(price);
    let [intPart, decimalPart] = price.toFixed(2).split(".");
    let firstDigit = parseInt(decimalPart[0]); // tenths
    let secondDigit = parseInt(decimalPart[1]); // hundredths

    if (secondDigit === 0 || secondDigit === 5) {
    // keep as-is
    } else if (secondDigit < 5) {
      secondDigit = 5;
    } else {
    // secondDigit is 6–9 → round up
      secondDigit = 0;
      firstDigit += 1;
      if (firstDigit === 10) {
        intPart = parseInt(intPart) + 1;
        firstDigit = 0;
      }
    }

    const finalDecimal = `${firstDigit}${secondDigit}`;
    return `${intPart}.${finalDecimal}`;
  } 

  function enrichComparePrice(rawBundlePrice, baseComparePrice, visiblePayPrice) {
    let bundlePrice = parseFloat(rawBundlePrice);
    let compare = parseFloat(baseComparePrice);
    let pay = parseFloat(visiblePayPrice);

    // Thresholds use the final visible pay price. The raw bundle price remains
    // the deterministic base for the compare-at price itself.
    if (isNaN(pay) || pay <= 0) pay = 0;
    const thresholdPrice = pay > 0 ? pay : bundlePrice;

    // 👉 BASE COMPARE INVALID
    if (isNaN(compare) || compare <= 0) {
      if (pay > 0) return roundToNearestFive(pay);
      $('.product-layout-multistep .atc__rd-price #ComparePrice').hide();
      return null;
    }

    // Himbeere always
    if (thresholdPrice >= COMPARE_VALUES.product1_threshold) {
      compare += COMPARE_VALUES.product1_value;
    }

    // Berry ≥ 99
    if (thresholdPrice >= COMPARE_VALUES.product2_threshold) {
      compare += COMPARE_VALUES.product2_value;
    }

    if(COMPARE_VALUES.product3_threshold != '' && COMPARE_VALUES.product3_threshold != 'undefined' && COMPARE_VALUES.product3_threshold != null){
      if (thresholdPrice >= COMPARE_VALUES.product3_threshold) {
        compare += COMPARE_VALUES.product3_value;
      }
    }

    // Shipping ≥ 79
    if (thresholdPrice >= COMPARE_VALUES.shipping_free_from) {
      compare += COMPARE_VALUES.shipping_value;
    }

    // Compare must NEVER be lower than pay
    if (pay > 0 && compare < pay) {
      compare = pay;
    }

    const roundedCompare = roundToNearestFive(compare);
    return roundedCompare;
  }

  // --- Compare-at-Price Erweiterung (nur Streichpreis) ---
  function updateCompareAtPrice(rawBundlePrice, upsellPrice, visiblePayPrice) {

    const upsellComparePrice = parseFloat(upsellPrice) || 0;
    const rawCompareBase = parseFloat(rawBundlePrice || 0) + upsellComparePrice;

    if (rawCompareBase <= 0 || visiblePayPrice <= 0) return;

    const compare = enrichComparePrice(
      rawBundlePrice,
      rawCompareBase,
      visiblePayPrice
    );

    if(compare > visiblePayPrice){
      console.log("updateCompareAtPrice fired", compare);
      $('.product-layout-multistep .atc__rd-price #ComparePrice')
      .html(
        '<span class="price-currency">CHF</span> ' +
        '<span class="price-integer">' + compare + '</span>'
      )
      .show();
    }else{
      console.log("updateCompareAtPrice not fired", compare);
      $('.product-layout-multistep .atc__rd-price #ComparePrice').hide();
    }

  }
  /****************/
  


  
  setTimeout(function(){
      if(element != '' && element != 'undefined' && element != null){
        element.css('visibility', 'visible');
      }
    }, 1000);
  
  function adjustFixedChildWidth() {
      var parentWidth = $('.main-product .product-text').width();
      $('.main-product .bundle_multistep__step.bundle_add_to_cart_options_step .bw-full.multistep__price-row').css('width', parentWidth);
  }


    if($(window).width() > 480){
      // Initial adjustment
      adjustFixedChildWidth();
  
      // Adjust on window resize
      $(window).resize(function() {
          adjustFixedChildWidth();
      });
    }

  var total_qty_limit_bundle = 0;  
  var total_selection = 0; var total_price = 0; var total_upsell_selection = 0; var total_bundle_selection = 0; var total_bundle_price = 0; var total_upsell_price = 0;
  var original_compare_price = $('.product-layout-multistep').attr('data-comp-price');
  var least_products_to_selected = $('.product-layout-multistep .bundle-products-selector-grid').attr('data-least-products');
  var data_total_products = $('.product-layout-multistep .bundle-products-selector-grid').attr('data-total-products');
  var selected_purchase_type = $('.product-layout-multistep .bundle_multistep__step.bundle_product__type_step div#rc_radio_options input[type="radio"]:checked').val();
  var price_per_item = 0;

  price_per_item = $('.product-layout-multistep .bundle_add_to_cart_options_step .order__item-price-per-nr-inner .order__item-price-per-nr-value span.price-integer').attr('data-per-item');
    
  
  if($('.bundle_upsell_step').length > 0){
    total_qty_limit_bundle = $('.bundle_upsell_step').attr('data-discount-qty');
  }else{
    total_qty_limit_bundle = 20;
  }


  function get_total_price_bundle(){
    var price_total = 0; var price = 0; 
    $('.bundle_multistep__change_form_qty').each(function(){
      price = price_per_item;
      if($(this).find('.js-qty-num').val() > 0){
          price_total += parseFloat(price)* parseFloat($(this).find('.js-qty-num').val());
      } 
    })
    
    price_total = parseFloat(price_total).toFixed(2);
    return price_total;
  }


  function get_total_bundle_count(){
    var bundleCount = 0; var price = 0; 
    $('.bundle_multistep__change_form_qty').each(function(){
      if($(this).find('.js-qty-num').val() > 0){
          bundleCount += parseFloat($(this).find('.js-qty-num').val());
      } 
    })
    return bundleCount;
  }
  
  
  function get_total_compare_price(visiblePayPrice){
    var rawBundlePrice = parseFloat(get_total_price_bundle());
    var upsellComparePrice = parseFloat(get_upsell_products_compare_price()) || 0;
    var payPrice = parseFloat(visiblePayPrice) || 0;

    if (isNaN(rawBundlePrice) || rawBundlePrice <= 0) {
      return '0.00';
    }


    var comparePrice = enrichComparePrice(
      rawBundlePrice,
      rawBundlePrice + upsellComparePrice,
      payPrice
    );

    return comparePrice === null
      ? '0.00'
      : parseFloat(comparePrice).toFixed(2);
  }

  function get_price_with_discount(item_price, discount_percentage){
      var discount_price_total = 0;  var discount_item_price = 0; 
      discount_item_price = parseFloat(parseFloat(item_price) * parseFloat(discount_percentage))/100;
      discount_item_price = parseFloat(item_price) - parseFloat(discount_item_price);
      discount_item_price = parseFloat(discount_item_price).toFixed(2);

      discount_price_total = parseFloat(discount_item_price).toFixed(2);
      return discount_price_total;
  }

	function get_price_with_fixed_discount(item_price, discount_fixed){
	  var price = parseFloat(item_price)|| 0; var discount = parseFloat(discount_fixed)|| 0;
	  // Subtract fixed discount per item
	  var discounted_price = price - discount;
	  // Ensure we never return negative prices
	  if(discounted_price < 0){
		  discounted_price = 0;
	  }
	  // Round to 2 decimal places
	  discounted_price = parseFloat(discounted_price.toFixed(2));
	  return discounted_price;
	}

    
	function get_total_price_after_discount(discount_percentage){
      var discount_price_total = 0;
      var discount = parseFloat(discount_percentage) || 0;

      // Shopify applies the percentage to each variant line total. Rounding a
      // single unit first creates drift after plus/minus changes (for example
      // CHF 82.18 instead of CHF 82.11 for 14 units at 15%).
      $('.bundle_multistep__change_form_qty').each(function(){
        var quantity = parseFloat($(this).find('.js-qty-num').val()) || 0;

        if(quantity > 0){
          var lineTotal = parseFloat(price_per_item) * quantity;
          var discountedLineTotal = lineTotal * (1 - (discount / 100));
          discount_price_total += parseFloat(discountedLineTotal.toFixed(2));
        }
      });

      return parseFloat(discount_price_total.toFixed(2));
    }

  function get_total_price_after_discount_without_fixed_two(discount_percentage){
      var discount_price_total = 0; 
      var check_num = parseFloat(discount_percentage) % parseFloat(5);
      if(check_num != 0){
        var item_total_price = 0; var cart_items_arr = [];  
        $('.bundle_multistep__change_form_qty').each(function(){
          price = price_per_item;
          if($(this).find('.js-qty-num').val() > 0){
            item_total_price = parseFloat(price)* parseFloat($(this).find('.js-qty-num').val());
            cart_items_arr.push(item_total_price);
          } 
        })
        
        if(cart_items_arr.length > 0){
          for(var i=0; i < cart_items_arr.length; i++){
            console.log(cart_items_arr[i]);
            var per_item_price = 0;
            
            per_item_price = parseFloat(cart_items_arr[i]) * parseFloat(discount_percentage);
            per_item_price = parseFloat(per_item_price) / parseFloat(100);
            /* per_item_price = Math.floor(per_item_price * 10) / 10; */
            per_item_price = parseFloat(cart_items_arr[i]) - parseFloat(per_item_price);
            //per_item_price = parseFloat(per_item_price.toFixed(2)); 
    
            discount_price_total += parseFloat(per_item_price);
          }
        }
      }else{
        var discount_item_price = 0; var per_item_price = 0;
        per_item_price = parseFloat(parseFloat(price_per_item) * parseFloat(discount_percentage)) / parseFloat(100);
        per_item_price = parseFloat(price_per_item) - parseFloat(per_item_price);
        //per_item_price = parseFloat(per_item_price.toFixed(2));
        
        $('.bundle_multistep__change_form_qty').each(function(){
          if($(this).find('.js-qty-num').val() > 0){
            discount_price_total += parseFloat(per_item_price) * parseFloat($(this).find('.js-qty-num').val()); 
          } 
        })
      }

      //discount_price_total = parseFloat(discount_price_total.toFixed(2));
      return discount_price_total;
    }
  

  function get_total_price_after_fixed_discount(discount_fixed){
    var discount_price_total = 0; 
    var check_num = parseFloat(discount_percentage) % parseFloat(5);

    if(discount_fixed > 0){
      var item_total_price = 0; var cart_items_arr = [];  
      $('.bundle_multistep__change_form_qty').each(function(){
        price = price_per_item;
        if($(this).find('.js-qty-num').val() > 0){
          item_total_price = parseFloat(price)* parseFloat($(this).find('.js-qty-num').val());
          var item_total_disconut  = parseFloat(discount_fixed) * parseFloat($(this).find('.js-qty-num').val());

          var per_item_price = 0;
          per_item_price = parseFloat(item_total_price) - parseFloat(item_total_disconut);
          discount_price_total += parseFloat(per_item_price);
          cart_items_arr.push(item_total_price);
        } 
      })
    
      /*if(cart_items_arr.length > 0){
        for(var i=0; i < cart_items_arr.length; i++){
          console.log(cart_items_arr[i]);
          var per_item_price = 0;
          
         // per_item_price = parseFloat(cart_items_arr[i]) * parseFloat(discount_percentage);
          //per_item_price = parseFloat(per_item_price) / parseFloat(100);
          // per_item_price = Math.floor(per_item_price * 10) / 10; 
          per_item_price = parseFloat(cart_items_arr[i]) - parseFloat(discount_fixed);
          per_item_price = parseFloat(per_item_price.toFixed(2)); 
  
          discount_price_total += parseFloat(per_item_price);
        }
      } */
    }else{
      var discount_item_price = 0; var per_item_price = 0;
      //per_item_price = parseFloat(parseFloat(price_per_item) * parseFloat(discount_percentage)) / parseFloat(100);
      per_item_price = parseFloat(price_per_item) - parseFloat(discount_fixed);
      per_item_price = parseFloat(per_item_price.toFixed(2));
      
      $('.bundle_multistep__change_form_qty').each(function(){
        if($(this).find('.js-qty-num').val() > 0){
          discount_price_total += parseFloat(per_item_price) * parseFloat($(this).find('.js-qty-num').val()); 
        } 
      })
    }

    discount_price_total = parseFloat(discount_price_total.toFixed(2));
    return discount_price_total;
  }
  
  function get_total_price_after_fixed_discount_without_fixed_two(discount_fixed){
    var discount_price_total = 0; 
    if(discount_fixed > 0){
      var item_total_price = 0; var cart_items_arr = [];  
      $('.bundle_multistep__change_form_qty').each(function(){
        price = price_per_item;
        if($(this).find('.js-qty-num').val() > 0){
          item_total_price = parseFloat(price)* parseFloat($(this).find('.js-qty-num').val());
          var item_total_disconut  = parseFloat(discount_fixed) * parseFloat($(this).find('.js-qty-num').val());
          var per_item_price = 0;
          per_item_price = parseFloat(item_total_price) - parseFloat(item_total_disconut);
          discount_price_total += parseFloat(per_item_price);
          cart_items_arr.push(item_total_price);
        } 
      })
      /*console.log(cart_items_arr);
      if(cart_items_arr.length > 0){
        for(var i=0; i < cart_items_arr.length; i++){
          console.log(cart_items_arr[i]);
          var per_item_price = 0;
          per_item_price = parseFloat(cart_items_arr[i]) - parseFloat(discount_fixed);
          //per_item_price = parseFloat(per_item_price.toFixed(2)); 
  
          discount_price_total += parseFloat(per_item_price);
        }
      } */
    }else{
      var discount_item_price = 0; var per_item_price = 0;
      //per_item_price = parseFloat(parseFloat(price_per_item) * parseFloat(discount_percentage)) / parseFloat(100);
      per_item_price = parseFloat(price_per_item) - parseFloat(discount_fixed);
      //per_item_price = parseFloat(per_item_price.toFixed(2));
      
      $('.bundle_multistep__change_form_qty').each(function(){
        if($(this).find('.js-qty-num').val() > 0){
          discount_price_total += parseFloat(per_item_price) * parseFloat($(this).find('.js-qty-num').val()); 
        } 
      })
    }

    //discount_price_total = parseFloat(discount_price_total.toFixed(2));
    return discount_price_total;
  }
  
  function get_upsell_products_price(){
      var upsell_price = 0; var upsell_items_price = 0;
      $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
        if($(this).find('.custom_upsell_product').is(':checked')){
          upsell_price = $(this).find('.custom_upsell_product').attr('data-price');
          upsell_items_price += parseFloat(upsell_price);
        }
      })

      upsell_items_price = parseFloat(upsell_items_price).toFixed(2);
      return upsell_items_price;
  }

  // function get_upsell_products_compare_price(){
  //     var upsell_price = 0; var upsell_items_price = 0;
  //     $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
  //       if($(this).find('.custom_upsell_product').is(':checked')){
  //         upsell_price = $(this).find('.custom_upsell_product').attr('data-comp-price');
  //         upsell_items_price += parseFloat(upsell_price);
  //       }
  //     })

  //     upsell_items_price = parseFloat(upsell_items_price).toFixed(2);
  //     return upsell_items_price;
  // }
  // -------------------2 FEB ---------------------
  function get_upsell_products_compare_price() {
  var upsell_items_price = 0;

  $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function () {
    var $checkbox = $(this).find('.custom_upsell_product');

    if ($checkbox.is(':checked')) {
      var price = parseFloat($checkbox.attr('data-comp-price'));

      // If no compare price or invalid → treat as 0
      if (!isNaN(price)) {
        upsell_items_price += price;
      }
    }
  });
  return upsell_items_price.toFixed(2);

}

    function get_upsell_products_price_after_discount(){
      var upsell_price = 0; var upsell_items_price = 0;
      $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
        if($(this).find('.custom_upsell_product').is(':checked')){
          upsell_price = $(this).find('.item-price .price-html').attr('data-dis-price');
          upsell_items_price += parseFloat(upsell_price);
        }
      })

      upsell_items_price = parseFloat(upsell_items_price).toFixed(2);
      return upsell_items_price;
    }

  function get_total_selected_bundle_count(){
      var total_count = 0;
      $('.bundle_multistep__change_form_qty').each(function(){
        total_count += parseInt($(this).find('.js-qty-num').val());
      })
      return total_count;
  }

  function get_total_selected_upsell_count(){
      var total_count = 0;
      $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
        if($(this).find('.custom_upsell_product').is(':checked')){
          total_count += 1;
        }
      })
      return total_count;
  }

  function make_atc_disabled(total_selected, products_to_selected) {
      if(total_selected < products_to_selected){
        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step button.bundle-add-to-cart').attr('disabled', true);
      }else{
        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step button.bundle-add-to-cart').removeAttr('disabled');
      }
  }

  function show_message_acc_count(count, price){
  var message = '';
  var remaining_packets = 0;
  var product_purchase_type = $('.product-layout-multistep .bundle_multistep__step.bundle_product__type_step div#rc_radio_options input[type="radio"]:checked').val();

  // Berechnung wie viele Starter noch fehlen
  if(count < 14 && count >= 6){
    remaining_packets = 14 - count;
  }else if(count >= 14 && count < 20){
    remaining_packets = 20 - count;
  }else if(count >= 20 && count < 30){
    remaining_packets = 30 - count;
  }

  if(product_purchase_type == 'onetime'){
    if(count < 6){
      message = window.ysThemeTranslate('product.minimumOrder', { count: 6 });
    }
    else if(price <= 79 && count >= 6){
      message = window.ysThemeTranslate('product.freeShippingFrom', { amount: 79 });
    }
    else if(price > 79 && count >= 6 && count < 14){
      message = window.ysThemeTranslate('product.addStartersSave', { remaining: remaining_packets, percent: 17 });
    }
    else if(count >= 14 && count < 20 && price > 79){
      message = window.ysThemeTranslate('product.addStartersSave', { remaining: remaining_packets, percent: 20 });
    }
    else if(count >= 20 && count < 30 && price > 79){
      message = window.ysThemeTranslate('product.addStartersSave', { remaining: remaining_packets, percent: 22 });
    }
    else if(count >= 30 && price > 79){
      message = window.ysThemeTranslate('product.congratulationsSaved', { percent: 22 });
    }
  }
  else if(product_purchase_type == 'autodeliver'){
    if(count < 6){
      message = window.ysThemeTranslate('product.minimumOrder', { count: 6 });
    }
    else if(price < 79 && count >= 6){
      message = window.ysThemeTranslate('product.freeShippingFrom', { amount: 79 });
    }
    else if(price >= 79){
      message = document.documentElement.lang.indexOf('fr') === 0 ? 'Félicitations ! Tu profites de la remise maximale sur ton abonnement.' : 'Glückwunsch! Du erhältst den maximalen Abo-Rabatt.';
    }
  }

  return message;
}

  

  function reset_bundle_add_to_cart_button(current){
      current.attr('aria-busy','false');
      current.find('.btn-atc').css('visibility','visible');
      current.find('.btn-atc').css('display','block');
      current.find('.multistep-button__preloader').removeClass('show');
      if($('.buyBox-sticky-atc-wrapper').length > 0){
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid button.sticky-atc-button').attr('aria-busy','false');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-atc-button span.sticky-addcart').show();
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-atc-button .multistep-button__preloader').removeClass('show');
      }
  }

  function get_cart_add_error_message(response){
      if(!response || typeof response !== 'object') return 'Cart add failed';

      return response.description || response.message || response.status || 'Cart add failed';
  }

  function custom_add_to_cart_bundle(product_items, current){
      if(!Array.isArray(product_items) || !product_items.length){
        return Promise.resolve();
      }

      let formData = {
       'items': product_items
      };

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json().catch(() => ({})).then(data => {
          if(!response.ok){
            var error = new Error(get_cart_add_error_message(data));
            error.response = data;
            throw error;
          }

          return data;
        });
      })
      .then(response => {
        reset_bundle_add_to_cart_button(current);
        refreshCart();
      
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            source: 'bundle-add-to-cart',
            cartAddResponse: response
          }
        }));
        document.dispatchEvent(new CustomEvent('ys:bundle-add:success', {
          detail: {
            items: product_items,
            cartAddResponse: response
          }
        }));
        console.log(response);

        return response;
      })
      .catch((error) => {
        reset_bundle_add_to_cart_button(current);
        document.dispatchEvent(new CustomEvent('ys:bundle-add:error', {
          detail: {
            items: product_items,
            error: error
          }
        }));
        console.error('Error:', error);
      });
  }
  
  
  total_bundle_selection = get_total_selected_bundle_count(); 
  total_upsell_selection = get_total_selected_upsell_count();

  total_selection = parseInt(total_bundle_selection);

  if(total_selection > 0){
      $('.product-layout-multistep .atc__rd-item-info span.TotalUnits').text(total_selection);
      if(total_selection == 1){
        $('.product-layout-multistep .atc__rd-item-info .pdp__order-item-info .order__item-nr-inner span.text-4xs').text(' Starter');
      }else{
        $('.product-layout-multistep .atc__rd-item-info .pdp__order-item-info .order__item-nr-inner span.text-4xs').text(' Starter');
      }
  }

    total_bundle_price = get_total_price_bundle();
    if(total_bundle_selection >= total_qty_limit_bundle){
      total_upsell_price = get_upsell_products_price_after_discount();
    }else{
      total_upsell_price = get_upsell_products_price();
    }
  
    total_price = parseFloat(total_bundle_price) + parseFloat(total_upsell_price);
    total_price = parseFloat(total_price.toFixed(2));
    total_price = roundToNearestFive(total_price);
    var raw_compare_base = parseFloat(total_bundle_price) + parseFloat(total_upsell_price);

/*
  if (total_price > 0) {

    var final_discount = 0;
    var final_price = 0;

    // ---------------------------------------- 1) Rabattlogik NUR fuer Zahlpreis  ---------------------------------------- 
    if (total_selection >= 14 && total_selection < 20) {
      final_discount = 2.795;
    } else if (total_selection >= 20 && total_selection < 30) {
      final_discount = 6.1957;
    } else if (total_selection >= 30) {
      final_discount = 12.415;
    }

    // ---------------------------------------- 2) Zahlpreis berechnen  ---------------------------------------- 
    if (final_discount > 0) {
      var discounted_base = get_total_price_after_discount_without_fixed_two(final_discount);
      final_price = parseFloat(discounted_base) + parseFloat(total_upsell_price);
    } else {
      final_price = parseFloat(total_price) + parseFloat(total_upsell_price);
    }

    final_price = parseFloat(final_price).toFixed(2);
    final_price = roundToNearestFive(final_price);

    $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer')
      .text(final_price);

    // ----------------------------------------  3) Compare At Price IMMER berechnen ---------------------------------------- 
    var compare_with_extras = enrichComparePrice(
      raw_compare_base,
      final_price
    );

    $('.product-layout-multistep .atc__rd-price #ComparePrice')
      .html(
        '<span class="price-currency">CHF</span> ' +
        '<span class="price-integer">' + compare_with_extras + '</span>'
      )
      .show();

  } */

	if (total_price > 0) {

    var final_discount = 0;
    var final_price = 0;

    // ---------------------------------------- 1) Rabattlogik NUR fuer Zahlpreis  ---------------------------------------- 
    if (total_selection >= total1 && total_selection < total2) {
      final_discount = discount1;
    } else if (total_selection >= total2 && total_selection < total3) {
      final_discount = discount2;
    } else if (total_selection >= total3) {
      final_discount = discount3;
    }
    //alert(final_discount);
    // ---------------------------------------- 2) Zahlpreis berechnen  ---------------------------------------- 
    if (final_discount > 0) {
      var discounted_base = get_total_price_after_fixed_discount_without_fixed_two(final_discount);
      final_price = parseFloat(discounted_base) + parseFloat(total_upsell_price);
    } else {
      final_price = parseFloat(total_price) + parseFloat(total_upsell_price);
    }

    final_price = parseFloat(final_price).toFixed(2);
    //final_price = roundToNearestFive(final_price);
    console.log('final test price',final_price);
    $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer')
      .text(final_price);

    // ----------------------------------------  3) Compare At Price IMMER berechnen ---------------------------------------- 
    var compare_with_extras = enrichComparePrice(
      total_bundle_price,
      raw_compare_base,
      final_price
    );
    //alert(compare_with_extras);
    $('.product-layout-multistep .atc__rd-price #ComparePrice')
      .html(
        '<span class="price-currency">CHF</span> ' +
        '<span class="price-integer">' + compare_with_extras + '</span>'
      )
      .show();

  }

  make_atc_disabled(total_selection, least_products_to_selected);

    var per_item_charge = 0;

    $('.product-layout-multistep .discount-bar').show();

    /* extra code  without change function 22 August 2024 */
    var purchase_types = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
    if(purchase_types == 'autodeliver'){
      $('.bundle_order__type-form').attr('selected_tab', 'rc_purchase_type_autodeliver_tab');
      var discount_percentage = 0;
      discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');
      var bundle_price = get_total_price_bundle();
      
      bundle_product_count = get_total_selected_bundle_count();
           
      var discount_price_per_item = get_price_with_discount(price_per_item, discount_percentage);
      var discount_price = get_total_price_after_discount(discount_percentage);
      
      /* if(selected_purchase_type == 'onetime'){
       per_item_price_text = price_per_item;
       $('.atc__rd-unit-qty .atc__rd-item-info span.order__item-price-per-nr-value span.price-integer').text(per_item_price_text);
      }else if(selected_purchase_type == 'autodeliver'){
       per_item_price_text = parseFloat(price_per_item) * parseFloat(15);
       per_item_price_text = parseFloat(per_item_price_text) / parseFloat(100);
       per_item_price_text = parseFloat(price_per_item) - parseFloat(per_item_price_text);
       $('.atc__rd-unit-qty .atc__rd-item-info span.order__item-price-per-nr-value span.price-integer').text(per_item_price_text);
      } */

      if(bundle_product_count >= total_qty_limit_bundle){
        var upsell_price = get_upsell_products_price_after_discount();
      }else{
        var upsell_price = get_upsell_products_price();
      }
  
      var total_price = parseFloat(bundle_price) + parseFloat(upsell_price);
      total_price = parseFloat(total_price).toFixed(2);

      //var discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percentage);
      var discount_price1 = get_total_price_after_discount(discount_percentage);
      var total_discount_price = parseFloat(discount_price1) + parseFloat(upsell_price);
      total_discount_price = parseFloat(total_discount_price).toFixed(2);
      //total_discount_price = roundToNearestFive(total_discount_price);


      let comparePrice = 0;
      let total_pay_price = 0;

      comparePrice = get_total_compare_price(total_discount_price);
      total_pay_price = parseFloat(comparePrice);

      total_pay_price = parseFloat(total_pay_price).toFixed(2);



      $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ProductPrice span.price-integer').html(total_discount_price);
      $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer test">'+total_pay_price+'</span>');
      // $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer test">'+total_price+'</span>');
      $('.product-layout-multistep .atc__rd-price span#ProductPrice').addClass('text-red-dark');

      if(discount_price_per_item != '' && discount_price_per_item != 'undefined' && discount_price_per_item != null){
        $('.pdp__order-item-info span.order__item-price-per-nr-value span.price-integer').html(discount_price_per_item);
        $('.multistep__price-row .shipping-text-grid span.price-integer').text(discount_price_per_item);
      }

      var msg = show_message_acc_count(total_selection, total_price);
      $('.product-layout-multistep .discount-bar span').html(msg);
      
      /* if(total_price > 79){
        $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
      }else if(total_price <= 79){
        $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
      } */
     
    }else{
      var msg = show_message_acc_count(total_selection, total_price);
      $('.product-layout-multistep .discount-bar span').html(msg);
      
      /* if(total_selection >= 30){
        $('.product-layout-multistep .discount-bar').addClass('discount-bar__is-green');
      }else{
        $('.product-layout-multistep .discount-bar').removeClass('discount-bar__is-green');
      } */

      /* if(total_selection >= 14 && total_selection < 20){
        per_item_charge = get_price_with_discount(price_per_item, 2.795);
      }else if(total_selection >=20 && total_selection < 30){
        per_item_charge = get_price_with_discount(price_per_item, 6.1957);
      }else if(total_selection >=30){
        per_item_charge = get_price_with_discount(price_per_item, 12.415);
      }else{
        per_item_charge = price_per_item;
      } */
	  
	  if(total_selection >= total1 && total_selection < total2){
        per_item_charge = get_price_with_fixed_discount(price_per_item, discount1);
      }else if(total_selection >=total2 && total_selection < total3){
        per_item_charge = get_price_with_fixed_discount(price_per_item, discount2);
      }else if(total_selection >=total3){
        per_item_charge = get_price_with_fixed_discount(price_per_item, discount3);
      }else{
        per_item_charge = price_per_item;
      } 
  
      if(per_item_charge > 0){
        $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_charge);
        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_charge);
      }
      
    }
    /* endcode */

    if(total_bundle_selection >= total_qty_limit_bundle){
      if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
        $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
          var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
          var nw_price = $(this).find('.item-detail .item-price .price-html').attr('data-dis-price');
          var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
          if(nw_price != '' && nw_price != 'undefined' && nw_price != null){
            $(this).find('.item-detail .item-price .price-html').html('<span>'+currency_symbol+' '+nw_price+'</span> <del>'+currency_symbol+' '+old_price+'</del>');
          } 
        }) 
      }
    }else{
      if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
        $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
          var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
          var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
          if(old_price != '' && old_price != 'undefined' && old_price != null){
            $(this).find('.item-detail .item-price .price-html').html(currency_symbol+' '+old_price);
          } 
        }) 
      }
    }  

    $('.product-layout-multistep button.js-qty__adjust--minus').on('click', function(){
		
      var noOfStep = $('.bundle-products-selector-grid.bundle_multistep__step').attr('data-step-to-add');
      if(noOfStep == null || noOfStep == '' || noOfStep == 0){
        noOfStep = 1;
      }
      var current_qty = $(this).closest('.js-qty').find('.js-qty-num').val();
      var new_qty = 0; var new_price = 0;

      var purchase_type = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
      var per_qty_price = $(this).closest('.bundle_multistep__change_form_qty').find('.js-variant-id').attr('data-price');
      var price = 0;
      var discount_price = 0;
      var upsell_items_price = 0;
      var bundle_product_count = 0;
      var upsell_product_count = 0;
      var dis_message = '';
      var discount_percentage = 0;
      var total_count = 0;
      
      discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');
      
      if (current_qty > 0) {
        /* new_qty = parseInt(current_qty) - 1; */
        new_qty = parseInt(current_qty) - parseInt(noOfStep);
        if(new_qty < 0){
          new_qty = 0;
        }
        $(this).closest('.js-qty').find('.js-qty-num').val(new_qty);
        price = get_total_price_bundle();
        bundle_product_count = get_total_selected_bundle_count();
        upsell_product_count = get_total_selected_upsell_count();

        if(bundle_product_count >= total_qty_limit_bundle){
          upsell_items_price = get_upsell_products_price_after_discount();
        }else{
          upsell_items_price = get_upsell_products_price();
        }
        
        total_count = parseInt(bundle_product_count) + parseInt(upsell_product_count);

        if($('.buyBox-sticky-atc-wrapper').length > 0){
          $('.buyBox-sticky-atc-wrapper .sticky-atc-bottle-icon .sticky-cart-items').html(total_count);
        }

        if(discount_percentage != '' && discount_percentage != 'undefined' && discount_percentage != null){
          discount_price = get_total_price_after_discount(discount_percentage); 
        }

        price = parseFloat(price) + parseFloat(get_upsell_products_price());
        price = parseFloat(price).toFixed(2);

        discount_price = parseFloat(discount_price) + parseFloat(upsell_items_price);
        discount_price = parseFloat(discount_price).toFixed(2);

        let comparePrice = 0;
        let total_pay_price = 0;

        comparePrice = get_total_compare_price(discount_price);
        total_pay_price = parseFloat(comparePrice);

        total_pay_price = parseFloat(total_pay_price).toFixed(2);

        if(purchase_type == 'onetime'){
          
          if(bundle_product_count >= total1 && bundle_product_count < total2){
            var discount_fixed = discount1; var coupon_discount_price = 0;
   
            /* per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);    
            coupon_discount_price = parseFloat(per_item_discount_price) * parseFloat(bundle_product_count);
            coupon_discount_price = parseFloat(coupon_discount_price).toFixed(2); */
            
            per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
            coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
            coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

            console.log('per_item_discount_price',per_item_discount_price);
            console.log('coupon_discount_price1',coupon_discount_price1);
            console.log('coupon_discount_price',coupon_discount_price);

            coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
            //coupon_discount_price = roundToNearestFive(coupon_discount_price);
            
            $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
            
            $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
            
           /*  updateCompareAtPrice(
              get_total_price_bundle(),   // roh, ohne Rabatt, ohne Rundung
              total_upsell_price,         // korrekt (discount oder nicht, wie bisher)
              coupon_discount_price       // ODER discount_price ODER final_price
            ); */

            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

            if($('.buyBox-sticky-atc-wrapper').length > 0){
              $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
            }
            
            var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
            $('.multistep__price-row .discount-bar span').html(dis_message);
            
            /* if(bundle_product_count >= 30){
              $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
            }else if(bundle_product_count < 30){
              $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
            } */

          }else if(bundle_product_count >= total2 && bundle_product_count < total3){
            
            var discount_fixed = discount2; var coupon_discount_price = 0;

            per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed); 
            coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
            coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

            coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
            //coupon_discount_price = roundToNearestFive(coupon_discount_price);

            $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
            
            $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
            
            /* updateCompareAtPrice(
              get_total_price_bundle(),
              upsell_items_price,
              coupon_discount_price
            ); */

            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

            if($('.buyBox-sticky-atc-wrapper').length > 0){
              $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
            }
            
            var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
            $('.multistep__price-row .discount-bar span').html(dis_message);
            
            /* if(bundle_product_count >= 30){
              $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
            }else if(bundle_product_count < 30){
              $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
            } */

          }else if(bundle_product_count >= total3){
            var discount_fixed =  discount3; var coupon_discount_price = 0;
            
            per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed); 
            coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
            coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

            coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
            //coupon_discount_price = roundToNearestFive(coupon_discount_price);

            $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
            
            $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
            
            /* updateCompareAtPrice(
              get_total_price_bundle(),
              upsell_items_price,
              coupon_discount_price
            ); */

            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

            if($('.buyBox-sticky-atc-wrapper').length > 0){
              $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
            }
            
            var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
            $('.multistep__price-row .discount-bar span').html(dis_message);
            
            /* if(bundle_product_count >= 30){
              $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
            }else if(bundle_product_count < 30){
              $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
            } */

          }else{
            var discount_fixed = 0; var coupon_discount_price = 0;

            per_item_discount_price = get_price_with_fixed_discount(price_per_item, discount_fixed);
            coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
            coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

            console.log('per_item_discount_price',per_item_discount_price);
            console.log('coupon_discount_price1',coupon_discount_price1);
            console.log('coupon_discount_price',coupon_discount_price);

            coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
            //coupon_discount_price = roundToNearestFive(coupon_discount_price);

            //price = roundToNearestFive(price);
            
            $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(price_per_item);
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(price_per_item);
            
            $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(price);
           

            if($('.buyBox-sticky-atc-wrapper').length > 0){
              $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+price);
            }

            var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
            $('.multistep__price-row .discount-bar span').html(dis_message);
           
            if (bundle_product_count >=1 ){
              /* updateCompareAtPrice(
                get_total_price_bundle(),
                upsell_items_price,
                coupon_discount_price
              ); */

              $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
              $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

            }else{
              $('.product-layout-multistep .atc__rd-price #ComparePrice').hide();
              
            }

            /* if(bundle_product_count >= 30){
              $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
            }else if(bundle_product_count < 30){
              $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
            } */
          }
          
        }else if(purchase_type == 'autodeliver'){
          
          //discount_price = roundToNearestFive(discount_price);
          
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(discount_price);

          /* updateCompareAtPrice(
            get_total_price_bundle(),
            upsell_items_price,
            discount_price
          ); */

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);

          /* if(discount_price > 79 && bundle_product_count > 5){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(discount_price <= 79){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          }else if(bundle_product_count < 6){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
          
        }
        
        var finalVisiblePayPrice = purchase_type == 'onetime'
          ? (bundle_product_count >= total1 ? coupon_discount_price : price)
          : discount_price;

        updateCompareAtPrice(
          get_total_price_bundle(),
          get_upsell_products_compare_price(),
          finalVisiblePayPrice
        );

        $('.product-layout-multistep .atc__rd-item-info span.TotalUnits').text(bundle_product_count);
        make_atc_disabled(bundle_product_count, least_products_to_selected);

        if(bundle_product_count >= total_qty_limit_bundle){
          if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
            $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
              var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
              var nw_price = $(this).find('.item-detail .item-price .price-html').attr('data-dis-price');
              var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
              if(nw_price != '' && nw_price != 'undefined' && nw_price != null){
                $(this).find('.item-detail .item-price .price-html').html('<span>'+currency_symbol+' '+nw_price+'</span> <del>'+currency_symbol+' '+old_price+'</del>');
              } 
            }) 
          }
        }else{
          if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
            $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
              var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
              var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
              if(old_price != '' && old_price != 'undefined' && old_price != null){
                $(this).find('.item-detail .item-price .price-html').html(currency_symbol+' '+old_price);
              } 
            }) 
          }
        } 
      }

  })


  $('.product-layout-multistep button.js-qty__adjust--plus').on('click', function(){
      var noOfStep = $('.bundle-products-selector-grid.bundle_multistep__step').attr('data-step-to-add');
      if(noOfStep == null || noOfStep == '' || noOfStep == 0){
        noOfStep = 1;
      }
      var current_qty = $(this).closest('.js-qty').find('.js-qty-num').val();
      var new_qty = 0; var new_price = 0;

      var per_qty_price = $(this).closest('.bundle_multistep__change_form_qty').find('.js-variant-id').attr('data-price');
      var purchase_type = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
      var price = 0;
      var discount_price = 0;
      var bundle_product_count = 0;
      var upsell_product_count = 0;
      var upsell_items_price = 0;
      var discount_percentage = 0;
      var total_count = 0;
      discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');

      /* new_qty = parseInt(current_qty) + 1; */
      new_qty = parseInt(current_qty) + parseInt(noOfStep);
      $(this).closest('.js-qty').find('.js-qty-num').val(new_qty);
      price = get_total_price_bundle();
      
      bundle_product_count = get_total_selected_bundle_count();
      upsell_product_count = get_total_selected_upsell_count();
      total_count = parseInt(bundle_product_count) + parseInt(upsell_product_count);

      if($('.buyBox-sticky-atc-wrapper').length > 0){
        $('.buyBox-sticky-atc-wrapper .sticky-atc-bottle-icon .sticky-cart-items').html(total_count);
      }

      discount_price = get_total_price_after_discount(discount_percentage);

      if(bundle_product_count >= total_qty_limit_bundle){
        upsell_items_price = get_upsell_products_price_after_discount();
      }else{
        upsell_items_price = get_upsell_products_price();
      }

      price = parseFloat(price) + parseFloat(get_upsell_products_price());
      price = parseFloat(price).toFixed(2);

      discount_price = parseFloat(discount_price) + parseFloat(upsell_items_price);
      discount_price = parseFloat(discount_price).toFixed(2);

      let comparePrice = 0;
      let total_pay_price = 0;

      comparePrice = get_total_compare_price(discount_price);
      total_pay_price = parseFloat(comparePrice);

      total_pay_price = parseFloat(total_pay_price).toFixed(2);

      if(purchase_type == 'onetime'){
        if(bundle_product_count >= total1 && bundle_product_count < total2){
          var discount_fixed = discount1; var coupon_discount_price = 0;
          /*
          var discount_percent = 2.795; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent); 
          
          coupon_discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percent);
          coupon_discount_price = get_total_price_after_discount(discount_percent);
          */
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
	        coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
        	coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

	        console.log('per_item_discount_price',per_item_discount_price);
          console.log('coupon_discount_price1',coupon_discount_price1);
	        console.log('coupon_discount_price',coupon_discount_price);   
			

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
          //coupon_discount_price = roundToNearestFive(coupon_discount_price);

          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
          
          /* updateCompareAtPrice(
            get_total_price_bundle(),
            upsell_items_price,
            coupon_discount_price
          ); */


          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
          
		    }else if(bundle_product_count >= total2 && bundle_product_count < total3){
          var discount_fixed = discount2; var coupon_discount_price = 0;
          /* var discount_percent = 6.1957; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);
          coupon_discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percent);
          coupon_discount_price = get_total_price_after_discount(discount_percent);
          */
		  
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
          coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
          coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          console.log('per_item_discount_price',per_item_discount_price);
          console.log('coupon_discount_price1',coupon_discount_price1);
          console.log('coupon_discount_price',coupon_discount_price);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
          //coupon_discount_price = roundToNearestFive(coupon_discount_price);
    
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
          
          /* updateCompareAtPrice(
            get_total_price_bundle(),
            upsell_items_price,
            coupon_discount_price
          ); */

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();
         
          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
          
        }else if(bundle_product_count >= total3){
          var discount_fixed = discount3; var coupon_discount_price = 0;
          /*var discount_percent = 12.415; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);
          coupon_discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percent);
          coupon_discount_price = get_total_price_after_discount(discount_percent); */
		  
		      per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
          coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
          coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          console.log('per_item_discount_price',per_item_discount_price);
          console.log('coupon_discount_price1',coupon_discount_price1);
          console.log('coupon_discount_price',coupon_discount_price);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
          //coupon_discount_price = roundToNearestFive(coupon_discount_price);
          
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
          
          
          /* updateCompareAtPrice(
            get_total_price_bundle(),
            upsell_items_price,
            coupon_discount_price
          ); */

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */

        }else{
          /* var discount_percent = 0; var coupon_discount_price = 0;

          per_item_discount_price = get_price_with_discount(price_per_item, discount_percent);
          coupon_discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percent);
          coupon_discount_price = get_total_price_after_discount(discount_percent); */

          var discount_fixed = 0; var coupon_discount_price = 0;
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
          coupon_discount_price1 = get_total_price_after_fixed_discount_without_fixed_two(discount_fixed);
          coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          console.log('per_item_discount_price',per_item_discount_price);
          console.log('coupon_discount_price1',coupon_discount_price1);
          console.log('coupon_discount_price',coupon_discount_price);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price1) + parseFloat(upsell_items_price)).toFixed(2);
          //coupon_discount_price = roundToNearestFive(coupon_discount_price);

          //price = roundToNearestFive(price);
          
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(price_per_item);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(price_per_item);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(price);
          

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+price);
          }

          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */

          /* updateCompareAtPrice(
            get_total_price_bundle(),
            upsell_items_price,
            coupon_discount_price
          ); */

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();
        }
      
      }else if(purchase_type == 'autodeliver'){

        //discount_price = roundToNearestFive(discount_price);
        
        $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(discount_price);

        /* updateCompareAtPrice(
          get_total_price_bundle(),
          upsell_items_price,
          coupon_discount_price
        ); */

        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
        

        if($('.buyBox-sticky-atc-wrapper').length > 0){
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+discount_price);
        }
        
        var dis_message = show_message_acc_count(total_count, discount_price);
        $('.multistep__price-row .discount-bar span').html(dis_message);
        
        /* if(discount_price > 79 && bundle_product_count > 5){
          $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
        }else if(discount_price <= 79){
          $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
        }else if(bundle_product_count < 6){
          $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
        } */
          
      }

      var finalVisiblePayPrice = purchase_type == 'onetime'
        ? (bundle_product_count >= total1 ? coupon_discount_price : price)
        : discount_price;

      updateCompareAtPrice(
        get_total_price_bundle(),
        get_upsell_products_compare_price(),
        finalVisiblePayPrice
      );

      $('.product-layout-multistep .atc__rd-item-info span.TotalUnits').text(bundle_product_count);

      make_atc_disabled(bundle_product_count, least_products_to_selected);

      if(bundle_product_count >= total_qty_limit_bundle){
        if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
          $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
            var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
            var nw_price = $(this).find('.item-detail .item-price .price-html').attr('data-dis-price');
            var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
            if(nw_price != '' && nw_price != 'undefined' && nw_price != null){
              $(this).find('.item-detail .item-price .price-html').html('<span>'+currency_symbol+' '+nw_price+'</span> <del>'+currency_symbol+' '+old_price+'</del>');
            } 
          }) 
        }
      }else{
        if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
          $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
            var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
            var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
            if(old_price != '' && old_price != 'undefined' && old_price != null){
              $(this).find('.item-detail .item-price .price-html').html(currency_symbol+' '+old_price);
            } 
          }) 
        }
      } 
  })


  $('.product-layout-multistep .bundle_add_to_cart_options_step .multistep__bottom-atc-items button.bundle-add-to-cart').on('click', function(e){
      e.preventDefault();

      var products_items_arr = [];
      var missing_selling_plan = false;
      var purchase_type = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
      var selling_plan = $('.product-layout-multistep .bottom__order-type-items #rc_autodeliver_options .shipping__interval_custom-dropdown .selected__value-drop').attr('data-name');

      $(this).attr('aria-busy','true');
      $(this).find('.btn-atc').hide();
      $(this).find('.multistep-button__preloader').addClass('show');

      if($('.buyBox-sticky-atc-wrapper').length > 0){
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid button.sticky-atc-button').attr('aria-busy','true');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-atc-button span.sticky-addcart').hide();
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-atc-button .multistep-button__preloader').addClass('show');
      }
      
      $('.bundle_multistep__change_form_qty').each(function(){
        if($(this).find('.js-qty-num').val() > 0){
          var current_selected_variant = $(this).find('.js-variant-id').val();
          var current_qty = $(this).find('.js-qty-num').val();
          var product_id = $(this).closest('.bundle_multistep_product__item').attr('data-product-id');

          var selling_plan_id = $(this).closest('.bundle_multistep_product__item').find('.bundle_selling_plan_wrap .bundle-selling-plan-item[data-plan-name="'+selling_plan+'"]').attr('data-plan-id');

          if(purchase_type == 'autodeliver'){
            if(!selling_plan_id){
              missing_selling_plan = true;
              console.error('Missing selling plan for bundle variant:', current_selected_variant, selling_plan);
              return false;
            }

            products_items_arr.push({'id':current_selected_variant, 'quantity': current_qty, 'selling_plan': selling_plan_id}); 
            /* products_items_arr.push({'collectionId': '', 'externalProductId': product_id, 'externalVariantId': current_selected_variant, 'quantity': current_qty, 'sellingPlan': selling_plan_id }); */
          }else if(purchase_type == 'onetime'){
            products_items_arr.push({'id':current_selected_variant, 'quantity': current_qty});
          }
        } 
      })

      $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
        if($(this).find('.custom_upsell_product').is(':checked')){
          var current_selected_variant = $(this).find('.custom_upsell_product').val();
          if(purchase_type == 'autodeliver'){
            if($(this).attr('data-pid') == 14834660376949){
              var upsell_plan_id = $('.bundle-upsell-item[data-pid="14834660376949"] .upsell_selling_plan_wrap .upsell-selling-plan-item[data-plan-name="'+selling_plan+'"]').attr('data-plan-id');
              if(upsell_plan_id){
                products_items_arr.push({'id':current_selected_variant, 'quantity': 1, 'selling_plan': upsell_plan_id});
              }else{
                console.warn('Missing selling plan for optional upsell variant, adding without selling plan:', current_selected_variant, selling_plan);
                products_items_arr.push({'id':current_selected_variant, 'quantity': 1});
              }
            }else{
              products_items_arr.push({'id':current_selected_variant, 'quantity': 1});
            }
          }else{
            products_items_arr.push({'id':current_selected_variant, 'quantity': 1});
          }
        }
      })

      if(missing_selling_plan){
        reset_bundle_add_to_cart_button($(this));
        document.dispatchEvent(new CustomEvent('ys:bundle-add:error', {
          detail: {
            items: products_items_arr,
            error: new Error('Missing selling plan for bundle item')
          }
        }));
        return;
      }
    
    
      if(products_items_arr != '' && products_items_arr != 'undefined' && products_items_arr != null){
        custom_add_to_cart_bundle(products_items_arr, $(this));
      } 

  })

  
  $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item .item-detail input.custom_upsell_product').on('change', function(){
      var purchase_type = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
      var bundle_product_count = 0; var upsell_product_count = 0; var total_count = 0;
      if($(this).is(':checked')){

 

        if(purchase_type == 'autodeliver'){
          
          var discount_percentage = 0;
          discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');
          var bundle_price = get_total_price_bundle();
          
          bundle_product_count = get_total_selected_bundle_count();
          upsell_product_count = get_total_selected_upsell_count();

          total_count = parseInt(bundle_product_count) + parseInt(upsell_product_count);

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-atc-bottle-icon .sticky-cart-items').html(total_count);
          }
               
          var discount_price_per_item = get_price_with_discount(price_per_item, discount_percentage);
          var discount_price = get_total_price_after_discount(discount_percentage);

          if(bundle_product_count >= total_qty_limit_bundle){
            var upsell_price = get_upsell_products_price_after_discount();
          }else{
            var upsell_price = get_upsell_products_price();
          }

          var total_price = parseFloat(bundle_price) + parseFloat(get_upsell_products_price());
          total_price = parseFloat(total_price).toFixed(2);

          let comparePrice = 0;
          let total_pay_price = 0;

          var total_discount_price = parseFloat(discount_price) + parseFloat(upsell_price);
          var discount_price1 = get_total_price_after_discount_without_fixed_two(discount_percentage);
          var total_discount_price = parseFloat(discount_price1) + parseFloat(upsell_price);
          total_discount_price = parseFloat(total_discount_price).toFixed(2);
          comparePrice = get_total_compare_price(total_discount_price);
          total_pay_price = parseFloat(comparePrice).toFixed(2);
          //total_discount_price = roundToNearestFive(total_discount_price);
          
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ProductPrice span.price-integer').html(total_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+total_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, total_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          
          /* if(total_discount_price > 79 && bundle_product_count > 5){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(total_discount_price <= 79){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          }else if(bundle_product_count < 6){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
          
        }else if(purchase_type == 'onetime'){
          var price = get_total_price_bundle();
          
          var bundle_price_per_item = 0;  var bundle_price = 0;

          bundle_product_count = get_total_selected_bundle_count();

          if(bundle_product_count >= total_qty_limit_bundle){
            var upsell_price = get_upsell_products_price_after_discount();
          }else{
            var upsell_price = get_upsell_products_price();
          }

          /* if(bundle_product_count >= 14 && bundle_product_count < 20){
              bundle_price_per_item = get_price_with_discount(price_per_item, 2.795);
              bundle_price = get_total_price_after_discount_without_fixed_two(2.795);
          }else if(bundle_product_count >= 20 && bundle_product_count < 30){
              bundle_price_per_item = get_price_with_discount(price_per_item, 6.1957);
              bundle_price = get_total_price_after_discount_without_fixed_two(6.1957);
          }else if(bundle_product_count >= 30){
              bundle_price_per_item = get_price_with_discount(price_per_item, 12.415);
              bundle_price = get_total_price_after_discount_without_fixed_two(12.415);
          }else{
              bundle_price_per_item = price_per_item;
              bundle_price = price;
          } */
		  
		      if(bundle_product_count >= total1 && bundle_product_count < total2){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount1);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount1);
          }else if(bundle_product_count >= total2 && bundle_product_count < total3){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount2);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount2);
          }else if(bundle_product_count >= total3){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount3);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount3);
          }else{
              bundle_price_per_item = price_per_item;
              bundle_price = price;
          } 

          var total_discount_price = parseFloat(bundle_price) + parseFloat(upsell_price);
          total_discount_price = parseFloat(total_discount_price).toFixed(2); 
          
          var total_price = parseFloat(price) + parseFloat(get_upsell_products_price());
          total_price = parseFloat(total_price).toFixed(2);

          //total_discount_price = roundToNearestFive(total_discount_price);
          
          var rawBundlePrice  = parseFloat(price); // original bundle price
          var rawUpsellPrice  = parseFloat(get_upsell_products_price());

          // visible pay price (WITH discounts)
          var visiblePayPrice = parseFloat(total_discount_price);

          let comparePrice = 0;
          let total_pay_price = 0;

          comparePrice = get_total_compare_price(visiblePayPrice);
          total_pay_price = parseFloat(comparePrice);

          total_pay_price = parseFloat(total_pay_price).toFixed(2);

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ProductPrice span.price-integer').html(total_discount_price);
          if(bundle_product_count >= 14){
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
            
            /* updateCompareAtPrice(
                comparePrice,
                rawUpsellPrice,
                visiblePayPrice
              ); */
          }else{
              // update compare-at price centrally
              /* updateCompareAtPrice(
                comparePrice,
                rawUpsellPrice,
                visiblePayPrice
              ); */

              $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          }

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+total_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, total_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          
          /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */

        }
        
      }else{
        if(purchase_type == 'autodeliver'){
          var discount_percentage = 0;
          discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');
          
          var bundle_price = get_total_price_bundle();
          
          bundle_product_count = get_total_selected_bundle_count();
          upsell_product_count = get_total_selected_upsell_count();

          var discount_price_per_item = get_price_with_discount(price_per_item, discount_percentage);
          var discount_price = get_total_price_after_discount_without_fixed_two(discount_percentage);
           
          if(bundle_product_count >= total_qty_limit_bundle){
            var upsell_price = get_upsell_products_price_after_discount();
          }else{
            var upsell_price = get_upsell_products_price();
          }
          
          var total_price = parseFloat(bundle_price) + parseFloat(get_upsell_products_price());
          total_price = parseFloat(total_price).toFixed(2);

          let comparePrice = 0;
          let total_pay_price = 0;

          var total_discount_price = parseFloat(discount_price) + parseFloat(upsell_price);
          total_discount_price = parseFloat(total_discount_price).toFixed(2);
          comparePrice = get_total_compare_price(total_discount_price);
          total_pay_price = parseFloat(comparePrice).toFixed(2);

          //total_discount_price = roundToNearestFive(total_discount_price); 
           
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ProductPrice span.price-integer').html(total_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+total_discount_price);
          }
           
          var dis_message = show_message_acc_count(bundle_product_count, total_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
           
          /* if(total_discount_price > 79 && bundle_product_count > 5){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(total_discount_price <= 79){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          }else if(bundle_product_count < 6){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
  
        }else if(purchase_type == 'onetime'){
          var price = get_total_price_bundle();
          
          var bundle_price_per_item = 0;  var bundle_price = 0;

          bundle_product_count = get_total_selected_bundle_count(); 
           
          if(bundle_product_count >= total_qty_limit_bundle){
            var upsell_price = get_upsell_products_price_after_discount();
          }else{
            var upsell_price = get_upsell_products_price();
          }
           
          /* if(bundle_product_count >= 14 && bundle_product_count < 20){
              bundle_price_per_item = get_price_with_discount(price_per_item, 2.795);
              bundle_price = get_total_price_after_discount_without_fixed_two(2.795);
          }else if(bundle_product_count >= 20 && bundle_product_count < 30){
              bundle_price_per_item = get_price_with_discount(price_per_item, 6.1957);
              bundle_price = get_total_price_after_discount_without_fixed_two(6.1957);
          }else if(bundle_product_count >= 30){
              bundle_price_per_item = get_price_with_discount(price_per_item, 12.415);
              bundle_price = get_total_price_after_discount_without_fixed_two(12.415);
          }else{
              bundle_price_per_item = price_per_item;
              bundle_price = price;
          } */
		  
		      if(bundle_product_count >= total1 && bundle_product_count < total2){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount1);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount1);
          }else if(bundle_product_count >= total2 && bundle_product_count < total3){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount2);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount2);
          }else if(bundle_product_count >= total3){
              bundle_price_per_item = get_price_with_fixed_discount(price_per_item, discount3);
              bundle_price = get_total_price_after_fixed_discount_without_fixed_two(discount3);
          }else{
              bundle_price_per_item = price_per_item;
              bundle_price = price;
          }

          var total_discount_price = parseFloat(bundle_price) + parseFloat(upsell_price);
          total_discount_price = parseFloat(total_discount_price).toFixed(2); 
          
          var total_price = parseFloat(price) + parseFloat(get_upsell_products_price());
          total_price = parseFloat(total_price).toFixed(2);

          //total_discount_price = roundToNearestFive(total_discount_price);
          var rawBundlePrice  = parseFloat(price); // original bundle price
          var rawUpsellPrice  = parseFloat(get_upsell_products_price());

          // visible pay price (WITH discounts)
          var visiblePayPrice = parseFloat(total_discount_price);

          let comparePrice = 0;
          let total_pay_price = 0;

          comparePrice = get_total_compare_price(visiblePayPrice);
          total_pay_price = parseFloat(comparePrice);

          total_pay_price = parseFloat(total_pay_price).toFixed(2);

          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ProductPrice span.price-integer').html(total_discount_price);
          
          if(bundle_product_count >= 14){
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
           
             /* updateCompareAtPrice(
                rawBundlePrice,
                rawUpsellPrice,
                visiblePayPrice
              ); */
          }else{
            // update compare-at price centrally
            /* updateCompareAtPrice(
              rawBundlePrice,
              rawUpsellPrice,
              visiblePayPrice
            ); */
            $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
          }

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+total_discount_price);
          }

          var dis_message = show_message_acc_count(bundle_product_count, total_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          
           /* if(bundle_product_count >= 30){
            $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
          }else if(bundle_product_count < 30){
            $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
          } */
          
        }
      }
    
      // The event branches above all calculate total_discount_price. Pass that
      // deterministic final pay price directly instead of reading stale DOM text.
      updateCompareAtPrice(
        get_total_price_bundle(),
        get_upsell_products_compare_price(),
        parseFloat(total_discount_price)
      );

      bundle_product_count = get_total_selected_bundle_count();
      $('.product-layout-multistep .atc__rd-item-info span.TotalUnits').text(bundle_product_count);
  })
  

  $('.product-layout-multistep span.multi_open_nutri_section_mod').on('click', function(){
    $(this).closest('.multi_nutri__section_box').find('.multi-modal').addClass('multi-modal--open');
  })

  $('.product-layout-multistep .multi-modal__close').on('click', function(){
    $(this).closest('.multi_nutri__section_box').find('.multi-modal').removeClass('multi-modal--open');
  })
  

  $(document)
    .off('change.yourstarterPurchaseType', '.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]')
    .on('change.yourstarterPurchaseType', '.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]', function(){
    if($(this).val() == 'autodeliver'){
      $(this).closest('.bundle_order__type-form').attr('selected_tab', 'rc_purchase_type_autodeliver_tab');
      $(this).closest('.bundle_order__type-form').find('#rc_autodeliver_options').show();  
      $('.product-layout-multistep .atc__rd-price span#ProductPrice').addClass('text-red-dark');
      /* $('.product-layout-multistep .discount-bar').hide(); */

      var discount_percentage = 0; var price_per_item_with_discount = 0; var bundle_count = 0; var upsell_count = 0; var total_count = 0;
      discount_percentage = $(this).attr('data-discount');
      
      bundle_count = get_total_selected_bundle_count();
      upsell_count = get_total_selected_upsell_count();
      
      total_count = parseInt(bundle_count) + parseInt(upsell_count);

      console.log(price_per_item);
      console.log(discount_percentage);

      price_per_item_with_discount = get_price_with_discount(price_per_item, discount_percentage); 

      var price = get_total_price_bundle();
      var discount_price = get_total_price_after_discount(discount_percentage);
      
      if(bundle_count >= total_qty_limit_bundle){
        var upsell_items_price = get_upsell_products_price_after_discount();
      }else{
        var upsell_items_price = get_upsell_products_price();
      }

      price = parseFloat(price) + parseFloat(get_upsell_products_price());
      price = parseFloat(price).toFixed(2);

      discount_price = parseFloat(discount_price) + parseFloat(upsell_items_price);
      discount_price = parseFloat(discount_price).toFixed(2);
      //discount_price = roundToNearestFive(discount_price);

      $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(discount_price);

       /* updateCompareAtPrice(
          get_total_price_bundle(),
          upsell_items_price,
          discount_price
        ); */
      var comparePrice = 0; 
      var total_pay_price = 0; 
      comparePrice = get_total_compare_price(discount_price);
      total_pay_price = parseFloat(comparePrice);
      total_pay_price = parseFloat(total_pay_price).toFixed(2);
      $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>').show();


      $('.product-layout-multistep .order__item-price-per-nr-value span.price-integer').html(price_per_item_with_discount);
      $('.product-layout-multistep .bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').html(price_per_item_with_discount);

      dis_message = show_message_acc_count(bundle_count, price);
      $('.multistep__price-row .discount-bar span').html(dis_message);
      
      /* if(price > 79 && bundle_count > 5){
        $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
      }else if(price <= 79){
        $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
      }else if(bundle_count < 6){
        $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
      } */

      
    }else if($(this).val() == 'onetime'){
      var price_per_item_with_discount = 0;  var price = 0;
      bundle_count = get_total_selected_bundle_count();
      upsell_count = get_total_selected_upsell_count();
      var upsell_items_price = 0;
      
      total_count = parseInt(bundle_count) + parseInt(upsell_count);
      
      if(bundle_count >= total_qty_limit_bundle){
        upsell_items_price = get_upsell_products_price_after_discount();
      }else{
        upsell_items_price = get_upsell_products_price();
      }
      
      /* if(bundle_count >= 14 && bundle_count < 20){
        price_per_item_with_discount = get_price_with_discount(price_per_item, 2.795); 
        // price = get_total_price_after_discount(2.795);

        let discount = 2.795;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(price_now) * parseFloat(discount);
        price_with_discount = parseFloat(price_with_discount) / parseFloat(100);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else if(bundle_count >= 20 && bundle_count < 30){
        price_per_item_with_discount = get_price_with_discount(price_per_item, 6.1957); 
        // price = get_total_price_after_discount(6.1957);

        let discount = 6.1957;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(price_now) * parseFloat(discount);
        price_with_discount = parseFloat(price_with_discount) / parseFloat(100);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else if(bundle_count >= 30){
        price_per_item_with_discount = get_price_with_discount(price_per_item, 12.415); 
        price = get_total_price_after_discount(12.415);

        let discount = 12.415;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(price_now) * parseFloat(discount);
        price_with_discount = parseFloat(price_with_discount) / parseFloat(100);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else{
        price_per_item_with_discount = price_per_item;
        price = get_total_price_bundle();
      } */
      
      var comparePrice = 0; 
      var total_pay_price = 0; 
	  
	    if(bundle_count >= total1 && bundle_count < total2){
        price_per_item_with_discount = get_price_with_fixed_discount(price_per_item, discount1); 
        // price = get_total_price_after_discount(2.795);

        let discount = discount1;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(bundle_count) * parseFloat(discount);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else if(bundle_count >= total2 && bundle_count < total3){
        price_per_item_with_discount = get_price_with_discount(price_per_item, discount2); 
        // price = get_total_price_after_discount(6.1957);

        let discount = discount2;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(bundle_count) * parseFloat(discount);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else if(bundle_count >= total3){
        price_per_item_with_discount = get_price_with_discount(price_per_item, discount3); 
        //price = get_total_price_after_discount(discount3);

        let discount = discount3;
        let price_now = get_total_price_bundle();
        let price_with_discount = 0;

        price_with_discount = parseFloat(bundle_count) * parseFloat(discount);
        price_now = parseFloat(price_now) - parseFloat(price_with_discount);
        price = parseFloat(price_now).toFixed(2);

      }else{
        price_per_item_with_discount = price_per_item;
        price = get_total_price_bundle().toFixed(2);
      }  

      $(this).closest('.bundle_order__type-form').attr('selected_tab', 'rc_purchase_type_onetime_tab');
      $(this).closest('.bundle_order__type-form').find('#rc_autodeliver_options').hide(); 
      $('.product-layout-multistep .atc__rd-price span#ProductPrice').removeClass('text-red-dark');
      $('.product-layout-multistep .discount-bar').show(); 

      price = parseFloat(price) + parseFloat(upsell_items_price);
      price = parseFloat(price).toFixed(2);
      //price = roundToNearestFive(price);

      comparePrice = get_total_compare_price(price);
      total_pay_price = parseFloat(comparePrice).toFixed(2);

      $('.product-layout-multistep .atc__rd-price span#ProductPrice .price-integer').html(price);
      $('.product-layout-multistep .order__item-price-per-nr-value span.price-integer').html(price_per_item_with_discount);
      $('.product-layout-multistep .bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').html(price_per_item_with_discount);

	    if(bundle_count >= total1){
        var total_price = 0; var bundle_price = 0;
        bundle_price = get_total_price_bundle();
        total_price = parseFloat(bundle_price) + parseFloat(upsell_items_price);

        total_price = parseFloat(total_price).toFixed(2);

        console.log('get_total_price_bundle pp:',get_total_price_bundle());
        console.log('upsell_items_price pp:',get_total_price_bundle());
        console.log('total_price pp:',get_total_price_bundle());

        
        /* updateCompareAtPrice(
          get_total_price_bundle(),   // roh, vor Rabatt
          upsell_items_price,         // korrekt (discount oder nicht)
          total_price            // final_price / coupon_discount_price
        ); */

        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').html('<span class="price-currency">CHF</span> <span class="price-integer">'+total_pay_price+'</span>');
        $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#ComparePrice').show();



        dis_message = show_message_acc_count(bundle_count, price);
        $('.multistep__price-row .discount-bar span').html(dis_message);
        
        /* if(bundle_count < 30){
        $('.multistep__price-row .discount-bar').removeClass('discount-bar__is-green');
        }else if(bundle_count > 30){
        $('.multistep__price-row .discount-bar').addClass('discount-bar__is-green');
        } */

      }
	  }

  });



  $('.product-layout-multistep .bundle_multistep__step .bundle_multistep_product__item .bundle_multistep__change_form_qty .js-qty input').on('change', function(){
      var current_qty = $(this).val();
      var new_qty = 0; var new_price = 0;

      var per_qty_price = $(this).closest('.bundle_multistep__change_form_qty').find('.js-variant-id').attr('data-price');
      var purchase_type = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').val();
      var price = 0;
      var discount_price = 0;
      var bundle_product_count = 0;
      var upsell_product_count = 0;
      var upsell_items_price = 0;
      var discount_percentage = 0;
      var total_count = 0;
      discount_percentage = $('.product-layout-multistep .bundle_top__order-type-items #rc_radio_options input[type=radio]:checked').attr('data-discount');

      new_qty = current_qty;
      $(this).closest('.js-qty').find('.js-qty-num').val(new_qty);
      price = get_total_price_bundle();
      
      bundle_product_count = get_total_selected_bundle_count();
      upsell_product_count = get_total_selected_upsell_count();
      total_count = parseInt(bundle_product_count) + parseInt(upsell_product_count);

      if($('.buyBox-sticky-atc-wrapper').length > 0){
        $('.buyBox-sticky-atc-wrapper .sticky-atc-bottle-icon .sticky-cart-items').html(total_count);
      }

      discount_price = get_total_price_after_discount(discount_percentage);

      if(bundle_product_count >= total_qty_limit_bundle){
        upsell_items_price = get_upsell_products_price_after_discount();
      }else{
        upsell_items_price = get_upsell_products_price();
      }

      price = parseFloat(price) + parseFloat(get_upsell_products_price());
      price = parseFloat(price).toFixed(2);

      discount_price = parseFloat(discount_price) + parseFloat(upsell_items_price);
      discount_price = parseFloat(discount_price).toFixed(2);

      if(purchase_type == 'onetime'){
        if(bundle_product_count >= total1 && bundle_product_count < total2){
          /*
          var discount_percent = 2.795; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);   
          coupon_discount_price = get_total_price_after_discount(discount_percent);
          */
          var discount_fixed = discount1; var coupon_discount_price = 0; 
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
	        coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price) + parseFloat(upsell_items_price)).toFixed(2);

          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
          updateCompareAtPrice(
            get_total_price_bundle(),
            get_upsell_products_compare_price(),
            coupon_discount_price
          );



          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          
        }else if(bundle_product_count >= total2 && bundle_product_count < total3){
          /* var discount_percent = 6.1957; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);   
          coupon_discount_price = get_total_price_after_discount(discount_percent); */
		  
		  var discount_fixed = discount2; var coupon_discount_price = 0; 
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
	        coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price) + parseFloat(upsell_items_price)).toFixed(2);
    
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
          updateCompareAtPrice(
            get_total_price_bundle(),
            get_upsell_products_compare_price(),
            coupon_discount_price
          );



          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
          
        }else if(bundle_product_count >= total3){
          /* var discount_percent = 12.415; var coupon_discount_price = 0;
    
          per_item_discount_price = get_price_with_discount(per_qty_price, discount_percent);   
          coupon_discount_price = get_total_price_after_discount(discount_percent); 
		  */
		  var discount_fixed = discount3; var coupon_discount_price = 0; 
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
	        coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed);

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price) + parseFloat(upsell_items_price)).toFixed(2);
          
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(per_item_discount_price);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(per_item_discount_price);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
         updateCompareAtPrice(
            get_total_price_bundle(),
            get_upsell_products_compare_price(),
            coupon_discount_price
          );



          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+coupon_discount_price);
          }
          
          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);

        }else{
          /* var discount_percent = 0; var coupon_discount_price = 0;

          per_item_discount_price = get_price_with_discount(price_per_item, discount_percent);    
          coupon_discount_price = get_total_price_after_discount(discount_percent); */
		  
		  var discount_fixed = 0; var coupon_discount_price = 0; 
          per_item_discount_price = get_price_with_fixed_discount(per_qty_price, discount_fixed);   
	        coupon_discount_price = get_total_price_after_fixed_discount(discount_fixed); 

          coupon_discount_price = parseFloat(parseFloat(coupon_discount_price) + parseFloat(upsell_items_price)).toFixed(2);
          
          $('.order__item-price-per-nr-inner span.order__item-price-per-nr-value span.price-integer').text(price_per_item);
          $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step .shipping-text-grid span.uPrice span.price-integer').text(price_per_item);
    
          $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(price);
          

          if($('.buyBox-sticky-atc-wrapper').length > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+price);
          }

          var dis_message = show_message_acc_count(bundle_product_count, coupon_discount_price);
          $('.multistep__price-row .discount-bar span').html(dis_message);
        }
      
      }else if(purchase_type == 'autodeliver'){
        $('.product-layout-multistep .atc__rd-price #ProductPrice .price-integer').text(coupon_discount_price);
        updateCompareAtPrice(
          get_total_price_bundle(),
          get_upsell_products_compare_price(),
          coupon_discount_price
        );




        


              if($('.buyBox-sticky-atc-wrapper').length > 0){
                $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+discount_price);
              }
              
              var dis_message = show_message_acc_count(total_count, discount_price);
              $('.multistep__price-row .discount-bar span').html(dis_message);
      }

      $('.product-layout-multistep .atc__rd-item-info span.TotalUnits').text(bundle_product_count);

      make_atc_disabled(bundle_product_count, least_products_to_selected);

      if(bundle_product_count >= total_qty_limit_bundle){
        if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
          $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
            var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
            var nw_price = $(this).find('.item-detail .item-price .price-html').attr('data-dis-price');
            var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
            if(nw_price != '' && nw_price != 'undefined' && nw_price != null){
              $(this).find('.item-detail .item-price .price-html').html('<span>'+currency_symbol+' '+nw_price+'</span> <del>'+currency_symbol+' '+old_price+'</del>');
            }
          }) 
        }
      }else{
        if($('.bundle_multistep__step.bundle_upsell_step').length > 0){
          $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item').each(function(){
            var old_price = $(this).find('.item-detail .item-price .price-html').attr('data-price');
            var currency_symbol = $(this).find('.item-detail .item-price .price-html').attr('data-currency');
            if(old_price != '' && old_price != 'undefined' && old_price != null){
              $(this).find('.item-detail .item-price .price-html').html(currency_symbol+' '+old_price);
            } 
          }) 
        }
      } 
    })


  $('.product-layout-multistep .shipping__interval_custom-dropdown').on('click', function(){
      if(!$(this).hasClass('open')){
        $(this).addClass('open');
      }else{
        $(this).removeClass('open');
      }
  })


  $('.product-layout-multistep .bundle_multistep__step.bundle_add_to_cart_options_step span#plusShipping').on('click', function(e){
      e.preventDefault();
      var popup_heading = ''; var popup_content = '';
      popup_heading = $(this).closest('.bundle_add_to_cart_options_step').find('.popup-content-wrap .shipping-modal-content-grid .shipping-modal-heading').html();
      popup_content = $(this).closest('.bundle_add_to_cart_options_step').find('.popup-content-wrap .shipping-modal-content-grid .shipping-modal-content').html();

      if(popup_heading != '' && popup_heading != 'undefined' && popup_heading != null){
        $('#customPopupModal .modal-popup__title').html(popup_heading);
      }

      if(popup_content != '' && popup_content != 'undefined' && popup_content != null){
        $('#customPopupModal .modal-popup__body').html(popup_content);
        $('#customPopupModal').addClass('cs-modal--open');
      }

  })

    $('.product-layout-multistep .bundle_multistep__step .atc__form-benefits span#bulletPopup-opener').on('click', function(e){
      e.preventDefault();
      var popup_heading = ''; var popup_content = '';
      popup_heading = $(this).closest('.bundle_add_to_cart_options_step').find('.popup-content-wrap .bullet-point-modal-content-grid .bullet-modal-heading').html();
      popup_content = $(this).closest('.bundle_add_to_cart_options_step').find('.popup-content-wrap .bullet-point-modal-content-grid .bullet-modal-content').html();

      if(popup_heading != '' && popup_heading != 'undefined' && popup_heading != null){
        $('#customPopupModal .modal-popup__title').html(popup_heading);
      }

      if(popup_content != '' && popup_content != 'undefined' && popup_content != null){
        $('#customPopupModal .modal-popup__body').html(popup_content);
        $('#customPopupModal').addClass('cs-modal--open');
      }
  })

  $('#customPopupModal .cs-modal__close').on('click', function(e){
    e.preventDefault();
    $(this).closest('.cs-modal').removeClass('cs-modal--open');
  })


  $('#rc_autodeliver_options .shipping__interval_custom-dropdown .dropdown__items-list .dropdown__list-item').on('click',function(){
      var plan_id = $(this).attr('val');
      var plan_name = $(this).attr('data-name');
      var plan_name_html = $(this).html(); 

      if(plan_id != '' && plan_id != 'undefined' && plan_id != null){
        $(this).closest('.shipping__interval_custom-dropdown').find('.selected__value-drop').attr('val', plan_id);
        $(this).closest('.shipping__interval_custom-dropdown').find('.selected__value-drop').html(plan_name_html);
        $(this).closest('.shipping__interval_custom-dropdown').find('.selected__value-drop').attr('data-name', plan_name);
      }
      
  })

    /********************************** Ingredients Section ****************************************/
  
    /* $('.product-ingredients-main .product-box-content .popup-toggle-container span.toggle-ingredients').on('click', function(){
      if($(this).hasClass('toggle-show')){
        $(this).removeClass('toggle-show');
      }else{
        $(this).addClass('toggle-show');
      } 
      
      $('.ingredients-slider-grid .ingSlider').slick("refresh");
      $('.ingredients-slider-grid .ingContent').slick("refresh");
      $(this).closest('.ingredients-popup-wrap').find('.ingredients-slider-grid').toggleClass('open');
    })


    $('.ingredients-slider-grid .ingSlider').slick({
      dots: false,
      infinite: false,
      arrows: true,
      asNavFor: '.ingredients-slider-grid .ingContent',
      autoplay: false,
      slidesToShow: 3.5,
      slidesToScroll: 1,
        variableWidth: true, 
      prevArrow:"<div class='slick-prev-arrow slick-prev'><span class='ingarw'><img src='https://cdn.shopify.com/s/files/1/0825/5140/6870/files/pfeil_nach_links_a6dcb264-efe8-4e6c-a6c6-c7eecd870152.png?v=1741724496' alt='image'></span></div>",
      nextArrow:"<div class='slick-next-arrow slick-next'><span class='ingarw'><img src='https://cdn.shopify.com/s/files/1/0825/5140/6870/files/pfeil_nach_rechts_e9d68984-1aff-43d8-9ee1-0cb92411aa5a.png?v=1741724497' alt='image'></span></div>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3.2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 681,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 346,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.ingredients-slider-grid .ingContent').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: false,
      fade: true,
      asNavFor: '.ingredients-slider-grid .ingSlider'
    }); 
  
  
    $('.ingredients-slider-grid .ingSlider').on('afterChange', function(event, slick, currentSlide){
      // Remove class from all inner elements
      $('.ingredients-slider-grid .ingSlider .ing-slide-item').removeClass('active');
      
      // Add class to the inner element of the active slide
      $('.ingredients-slider-grid .ingSlider .slick-slide[data-slick-index="'+currentSlide+'"] .ing-slide-item').addClass('active');
    });


    $(document).on('click', '.ingredients-slider-grid .ingSlider .ing-slide-item', function(){
      var id = $(this).attr('data-id');
      $('.ingredients-slider-grid .ingSlider .ing-slide-item').removeClass('active');
      $(this).addClass('active');
      $('.ingContent .ingTabContent').removeClass('active');
      $('.ingContent .ingTabContent[data-id="'+id+'"]').addClass('active');
      $('.ingContent').slick('slickGoTo', id);
    });*/


     // Toggle popup
    document.querySelectorAll('.toggle-ingredients').forEach(btn => {
      btn.addEventListener('click', function() {
        this.classList.toggle('toggle-show');
        const grid = this.closest('.ingredients-popup-wrap')?.querySelector('.ingredients-slider-grid');
        if (grid) grid.classList.toggle('open');
      });
    });

    // Thumbnail Swiper
    const ingSlider = new Swiper('.ingSlider', {
      slidesPerView: 2.5,
      spaceBetween: 20,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.ing-next',
        prevEl: '.ing-prev',
      },
      breakpoints: {
        992: { slidesPerView: 6.5 },
        681: { slidesPerView: 4.5 },
        481: { slidesPerView: 3.5 }
      },
      on: {
        init: function () {
          const $prev = $(this.navigation.prevEl);
          const $next = $(this.navigation.nextEl);
          if ($prev.length && $next.length) {
            $prev.addClass('hidden');
            if (this.isEnd) $next.addClass('hidden');
          }
        },
        reachBeginning: function () {
          const $prev = $(this.navigation.prevEl);
          if ($prev.length) $prev.addClass('hidden');
        },
        fromEdge: function () {
          const $prev = $(this.navigation.prevEl);
          const $next = $(this.navigation.nextEl);
          if ($prev.length && $next.length) {
            $prev.removeClass('hidden');
            $next.removeClass('hidden');
          }
        },
        reachEnd: function () {
          const $next = $(this.navigation.nextEl);
          if ($next.length) $next.addClass('hidden');
        },
      },
    });

    // Content Swiper
    const ingContent = new Swiper('.ingContent', {
      slidesPerView: 1,
      effect: 'fade',
      autoHeight: true,
      allowTouchMove: false,
    });


    $(document).on('click', '.ingredients-slider-grid .ingSlider .ing-slide-item', function() {
      const $clickedItem = $(this);
      const $clickedSlide = $clickedItem.closest('.swiper-slide');
      const id = parseInt($clickedSlide.attr('data-id'), 10);

      // Update content swiper manually
      $('.ingContent .swiper-slide .ingTabContent').removeClass('active');
      $('.ingContent .swiper-slide[data-id="'+id+'"] .ingTabContent').addClass('active');

      // Trigger Swiper movement
      if (!isNaN(id)) {
        ingContent.slideTo(id, 500);
      }

      // Remove active from all .ing-slide-item elements inside THIS swiper
      $clickedSlide
        .closest('.ingSlider')
        .find('.ing-slide-item')
        .removeClass('active');

      // Add active only to the clicked item
      $clickedItem.addClass('active');

    });


    // ✅ Keep thumbnail active when content changes (optional sync)
    ingContent.on('slideChange', () => {
      const index = ingContent.activeIndex;
      document.querySelectorAll('.ing-slide-item').forEach(el => el.classList.remove('active'));
      const activeSlide = document.querySelector(`.ing-slide-item[data-id="${index}"]`);
      if (activeSlide) activeSlide.classList.add('active');
    });


    $('.product-layout-multistep .bundle_flavour_step .bundle_multistep_product__item .bundle_multistep__product-title-wrap .info-popup-btn').on('click', function(){
      var data_popup = $(this).attr('data-popup-id') || $(this).attr('data-popup');
      if(data_popup != '' && data_popup != 'undefined' && data_popup != null){
        var popup_content = ''; var popup_heading = '';
        var popup_target = $(this)
          .closest('.bundle_multistep_product__item')
          .find('.bundle_multistep_info_content_wrapper [id]')
          .filter(function(){
            return this.id === data_popup;
          });

        if(popup_target.length > 0){
          popup_heading = $(this).attr('data-heading');
          popup_content = popup_target.html();
          
          if(popup_heading != '' && popup_heading != 'undefined' && popup_heading != null){
            $('#customPopupModal .modal-popup__title').html(popup_heading);
          }
          if(popup_content != '' && popup_content != 'undefined' && popup_content != null){
            $('#customPopupModal .modal-popup__body').html(popup_content);
            $('#customPopupModal').addClass('cs-modal--open');
          }
        }
      }
    })


    $('#main-collection-product-grid .product-item.card .product-item__quick-buy button.product-item__custom-atc-btn, .featured-collection-wrap .product-item.card .product-item__quick-buy button.product-item__custom-atc-btn, .featured_collection_warper--item .product-item.card .product-item__quick-buy button.product-item__custom-atc-btn').on('click', function(e){
      e.preventDefault();
    
      var products_items_arr = [];

      var product_variant_id = $(this).closest('.product-item__quick-buy').attr('data-variant-id');

      var button_behaviour = $(this).attr('data-button-behaviour');
      
      if(button_behaviour == 'add_to_cart_product'){
        $(this).find('.btn-atc').css('visibility', 'hidden');
        $(this).find('.multistep-button__preloader').addClass('show');
  
        if($(this).closest('.product-item').find('.main-collection-bundle-grid').length > 0){
          $(this).closest('.product-item').find('.main-collection-bundle-grid .main-collection-bundle-item').each(function(){
            if($(this).attr('data-min-qty') > 0){
              var current_selected_variant = $(this).attr('data-vid');
              var current_qty = $(this).attr('data-min-qty');
              
              products_items_arr.push({'id':current_selected_variant, 'quantity': current_qty});
            } 
          })
        }
  
        if($(this).closest('.product-item').find('.main-collection-upsell-grid').length > 0){
          $(this).closest('.product-item').find('.main-collection-upsell-grid .main-collection-bupsell-item').each(function(){ 
             if($(this).attr('data-preselected') == 'true'){
              var current_selected_variant = $(this).attr('data-vid');
              products_items_arr.push({'id':current_selected_variant, 'quantity': 1});
            }
          })
        }
  
        if(products_items_arr == '' || products_items_arr == 'undefined' || products_items_arr == null){
          products_items_arr.push({'id': product_variant_id, 'quantity': 1});
        }
  
        if(products_items_arr != '' && products_items_arr != 'undefined' && products_items_arr != null){
          custom_add_to_cart_bundle(products_items_arr, $(this));
        }
        
      }else{
        var redirect_url = $(this).closest('.product-item__quick-buy').attr('data-redirect-url');
        window.location.href = redirect_url;
      }
  
    }) 


    $('#main-collection-product-grid').on('click', '.product-item.card .product-item__quick-buy .quick-add-to-cart-button button[data-js-product-add-to-cart], .product-item.card .product-item__quick-buy .quick-add-to-cart-button a[data-js-product-add-to-cart]', function(e) {
      var button_behaviour = $(this).data('button-behaviour');

      if (button_behaviour !== 'add_to_cart_product') {
        e.preventDefault();
        var redirectUrl = $(this).closest('.product-item__quick-buy').data('redirect-url');
      
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
      }
    });
  

    $('.product-gallery-item-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: false, 
      fade: true,
      asNavFor:'.product-gallery-thumbnail-slider'
    });
    
    $('.product-gallery-thumbnail-slider').slick({
      slidesToShow:7,
      slidesToScroll: 2,
      asNavFor:'.product-gallery-item-slider',
      autoplay: false, 
      infinite: false,
      focusOnSelect: true,
      arrows: false,
      dots: false,
      accessibility: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidersToShow: 6,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
          }
        }
      ]
    });

    setTimeout(function(){
      $('.product-gallery-slider-wrapper').css('visibility', 'visible');
    }, 1000);

    /***********************************************************************************************/

    /********** Sticky Add to Cart **************/

    if($('.buyBox-sticky-atc-wrapper').length > 0){
      if($('.product-layout-multistep').length > 0){
        if($('.bundle_add_to_cart_options_step').length > 0){
          var finalPrice = $('.bundle_add_to_cart_options_step #ProductPrice .price-integer').html();
          var finalItems = 0;
          if(finalPrice != '' && finalPrice != 'undefined' && finalPrice != null){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button .sticky-cart-subtotal').html('| CHF '+finalPrice);
          }
  
          if($('.bundle-products-selector-grid').length > 0){
            $('.bundle-products-selector-grid .bundle-js-main-product .bundle_multistep_product__item').each(function(){
              finalItems += parseFloat($(this).find('.js-qty .js-qty-num').val());
            })
          }
  
          if(finalItems > 0){
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon .sticky-cart-items').html(finalItems);
          }else{
            $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon .sticky-cart-items').html(1);
          }
        }
      }else{
        $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol.hide').css('flex','0');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol.hide').css('max-width','0');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').css('flex', '0 0 100%');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').css('max-width', '100%');
      }
    }

    $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-button button.sticky-atc-button').on('click', function (e) {
      e.preventDefault();
      
      let $button = $(this); // Store reference to the clicked button
      let $mainContent = $button.closest('.main-content');
      if($('.product-layout-multistep').length > 0){
        $mainContent.find('#addToCart').trigger('click');
      }
      else{
        // $mainContent.find('button[data-js-product-add-to-cart]').trigger('click');
        $mainContent.find('button[data-js-product-add-to-cart]').first().trigger('click');
        $button.find('.sticky-addcart').hide();
        $button.find('.multistep-button__preloader').addClass('show');
        setTimeout(function(){
          $button.find('.sticky-addcart').show();
          $button.find('.multistep-button__preloader').removeClass('show');
        }, 1500);
      }
    });
    /*********** End Sticky Add to Cart **********/


    $('.main-product .pdp-rating-main .star-rating__caption').on('click', function(e){
      var check_if_same = 0; 
      var product_review_count = $(this).text();

      if (product_review_count) {
        const product_review_match = product_review_count.match(/\d[\d'.,]*/);
        product_review_count = product_review_match ? product_review_match[0].replace(/[^\d]/g, "") : "";
      }

      if($('#judgeme_product_reviews').length > 0){
        var string  = $('#judgeme_product_reviews .jdgm-rev-widg__summary .jdgm-rev-widg__summary-text').text();
        if (string.includes(product_review_count)) {
          check_if_same = 1;
        }
      }

      if(check_if_same == 0){
        if($('.jdgm-carousel-wrapper').length > 0){
          e.preventDefault(); // prevent default anchor behavior
          $('html, body').animate({
            scrollTop: $('.jdgm-all-reviews-text').offset().top - 300
          }, 800); // 800ms animation 
        }
      }else{
        e.preventDefault(); // prevent default anchor behavior
        $('html, body').animate({
          scrollTop: $('#judgeme_product_reviews').offset().top
        }, 800); // 800ms animation 
      }

    })

  


  function on_page_load_calculate_origenal_price(){
    $('.bundle_multistep__step.bundle_upsell_step .bundle-upsell-item:first-child .item-detail input.custom_upsell_product').trigger('change');
  }
  on_page_load_calculate_origenal_price();
  
})


// ---------------------------------------new---------------
function initEmptyCartSwiper() {
  const swiperEl = document.querySelector(".emptyCartSwiper");
  if (swiperEl && !swiperEl.classList.contains("swiper-initialized")) {
    new Swiper(".emptyCartSwiper", {
      loop: false,
      centeredSlides: false,
      grabCursor: true,
      slidesPerGroup: 2,
      // loopAdditionalSlides: 3,
      spaceBetween: 10,
      speed: 600,
      
      //  these are fine-tuned values to match the “2 full + 1/5 peek” layout
      slidesPerView: 2.18,  // base

      breakpoints: {
        640: { slidesPerView: 2.13, slidesPerGroup: 2 },
        768: { slidesPerView: 2.14, slidesPerGroup: 2 },
        1024: { slidesPerView: 2.14, slidesPerGroup: 2 }, 
        1280: { slidesPerView: 2.40, slidesPerGroup: 2 },
      },
    });
    swiperEl.classList.add("swiper-initialized");
  }
}


document.addEventListener("DOMContentLoaded", function () {

  initEmptyCartSwiper();

  // Watch for DOM changes in cart container (backup for delete case)
  const cartSidebar = document.querySelector("#site-cart-sidebar");
  if (cartSidebar) {
    const observer = new MutationObserver(() => {
      const emptyCart = document.querySelector(".emptyCartSwiper");
      if (emptyCart && !emptyCart.classList.contains("swiper-initialized")) {
        setTimeout(() => initEmptyCartSwiper(), 200);
      }
    });
    observer.observe(cartSidebar, { childList: true, subtree: true });
  }

  function maybeInitEmptyCartSwiper(cart) {
    if (cart && Number(cart.item_count) === 0) {
      setTimeout(() => initEmptyCartSwiper(), 300);
    }
  }

  document.addEventListener("ys:cart:committed", (event) => {
    maybeInitEmptyCartSwiper(event.detail && event.detail.cart);
  });

  document.addEventListener("cart:updated", (event) => {
    const detail = event && event.detail ? event.detail : {};

    if (detail.stateCommitted) return;
    maybeInitEmptyCartSwiper(detail.cart);
  });

});

// -----------------------------------------------

/*
$(window).scroll(function(){
  var scrollPosition1 = $(window).scrollTop();
  if(element != '' && element != 'undefined' && element != null){
    if($(window).width() <= 767){
      if(scrollPosition1 > elementOffsetTop){
        element.addClass('disable_displace');
        element.removeClass('fixed');
        element.find('.shipping-text-grid').hide();
      }else{
        element.removeClass('disable_displace');
        element.addClass('fixed');
        element.find('.shipping-text-grid').show();
      }
    }
    else{
    //   element.addClass('disable_displace');
    //   element.removeClass('fixed');
    //   element.find('.shipping-text-grid').show();

      if(scrollPosition1 > elementOffsetTop){
        element.addClass('disable_displace');
        element.removeClass('fixed');
        element.find('.shipping-text-grid').hide();
      }else{
        element.removeClass('disable_displace');
        element.addClass('fixed');
        element.find('.shipping-text-grid').show();
      }
    }

  }
}) */

$(window).on('scroll resize load', function () {
  var $window = $(window);
  var $element = $('.bundle_add_to_cart_options_step');
  var $content = $('.main-product .product-text');
  var stickySection = $('.buyBox-sticky-atc-wrapper');
  if (!$element.length || !$content.length || !stickySection.length) return;

  var elementTop = $element.offset().top;
  var elementBottom = elementTop + $element.outerHeight();
  var viewportTop = $window.scrollTop();
  var viewportBottom = viewportTop + $window.height();

  // Check if element is currently visible in viewport
  var isVisible = (elementTop < viewportBottom);

  if (isVisible) {
    // If the bundle section is visible, don't make it sticky
    $element.removeClass('fixed').addClass('disable_displace');
    $element.find('.shipping-text-grid').hide();
  } else {
    // If it's not visible, make it sticky at bottom
    $element.addClass('fixed').removeClass('disable_displace');
    $element.find('.shipping-text-grid').show();
  }
});
